import { ButtonVariant } from '@components/buttons/button'
import { LanguageContext } from '@lib/language-context'
import { StringsContext } from '@lib/strings-context'
import { useContext, useEffect, useMemo, useState } from 'react'
import Countdown from 'react-countdown'
import ProductAdd from './product-add'

interface ProductAvailabilityCountdownProps {
  availabilityCountdownTarget: string
}

const ProductAvailabilityCountdown = ({
  availabilityCountdownTarget,
}: ProductAvailabilityCountdownProps) => {
  const { locale } = useContext(LanguageContext)
  const strings = useContext(StringsContext)

  const [isLoaded, setIsLoaded] = useState(false)

  useEffect(() => {
    if (!isLoaded) {
      setIsLoaded(true)
    }
  }, [isLoaded])

  const availabilityDescription = useMemo(() => {
    // Using "nl" locale here, since "en" locale does not produce timezone string "CEST" only "GMT+2"
    const timeFormat = new Intl.DateTimeFormat('nl', {
      hour: 'numeric',
      minute: 'numeric',
      hourCycle: 'h23',
      timeZoneName: 'short',
    })
    const dateFormat = new Intl.DateTimeFormat(locale, {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    })
    const date = new Date(availabilityCountdownTarget)
    const dateTimeString = `${timeFormat.format(date)}, ${dateFormat.format(date)}`

    return strings.productAvailabilityDescription?.replace(
      /{date}/gi,
      dateTimeString,
    )
  }, [locale, availabilityCountdownTarget, strings])

  if (!isLoaded) {
    return null
  }

  return (
    <div className="space-y-6">
      <p>{availabilityDescription}</p>

      <ProductAdd
        variant={ButtonVariant.FILLED}
        disabled
        onClick={async () => {}}
        className="w-full"
      >
        <Countdown
          date={availabilityCountdownTarget}
          renderer={({ formatted }) => (
            <span>
              {strings.productAvailabilityCountdownFormat
                .replace(/{days}/gi, formatted.days)
                .replace(/{hours}/gi, formatted.hours)
                .replace(/{minutes}/gi, formatted.minutes)
                .replace(/{seconds}/gi, formatted.seconds)}
            </span>
          )}
          onComplete={() => {
            window.location.reload()
          }}
        />
      </ProductAdd>
    </div>
  )
}

export default ProductAvailabilityCountdown
